import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/types';

import { DashboardCarrierStatitics, DashboardGiverStatitics } from './types';

export const DASHBOARD_ENPOINTS = {
  getDashboardCarrierStatitics: '/api/v1/Route/Report/DashboardCarrier',
  getDashboardGiverStatitics: '/api/v1/Route/Report/DashboardGiver',
};

export const getDashboardCarrierStatitics = (): ApiPromise<
  DataResponse<DashboardCarrierStatitics>,
  ErrorResponse
> =>
  API.post<DataResponse<DashboardCarrierStatitics>, ErrorResponse>(
    DASHBOARD_ENPOINTS.getDashboardCarrierStatitics,
  );

export const getDashboardGiverStatitics = (): ApiPromise<
  DataResponse<DashboardGiverStatitics>,
  ErrorResponse
> =>
  API.post<DataResponse<DashboardGiverStatitics>, ErrorResponse>(
    DASHBOARD_ENPOINTS.getDashboardGiverStatitics,
  );
